"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SURVEY_INIT_STATE = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const set_1 = __importDefault(require("lodash/set"));
const types_1 = require("src/types");
const consts_1 = require("../sagas/consts");
exports.SURVEY_INIT_STATE = {
    _ivid: '',
    branding: {},
    dir: 'ltr',
    displayHiddenQuestions: false,
    isPollStarted: false,
    lang: 'ru',
    metrika: [],
    metrikaCounters: [],
    metrikaTitle: '',
    retpath: '',
    revisionId: 1,
    scope: [types_1.SurveyScope.Yandex],
    slug: ''
};
// eslint-disable-next-line complexity, max-statements
exports.default = (state = (0, cloneDeep_1.default)(exports.SURVEY_INIT_STATE), action) => {
    var _a, _b;
    if (consts_1.QUESTION_INTERACTION_ACTIONS.includes(action.type)) {
        return Object.assign(Object.assign({}, state), { isPollStarted: true });
    }
    switch (action.type) {
        case 'SURVEY_SET_INITED':
        case 'SURVEY_LOADED_FROM_CONFIG': {
            const revision = action.data;
            const { status } = action;
            const { slug } = action.params;
            const { _ivid, _uid = null, branding, demoMode, dir = 'ltr', lang = 'ru', metrika = [], metrikaCounters = [], metrikaTitle = '', nextBtnBehaviour = 'visibleAndEnabled', redirects, revisionId = 1, scope, supportDarkMode, surveyPreset, screening } = revision;
            const retpath = (redirects && redirects.default) || '';
            const _seqnum = 2; // первый запрос это getSurvey
            const displayHiddenQuestions = false;
            const charLimits = Object.assign({
                shortText: 64
            }, revision.charLimits);
            const newState = (0, cloneDeep_1.default)(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (_ivid && { _ivid })), { _seqnum,
                _uid,
                charLimits, conditions: {}, lang,
                dir, inited: true, isPollStarted: false, metrika,
                metrikaCounters,
                metrikaTitle,
                retpath,
                revisionId,
                slug, start: true, status,
                displayHiddenQuestions,
                nextBtnBehaviour }), ((screening === null || screening === void 0 ? void 0 : screening.enabled) && { screening })), (scope && { scope })), (surveyPreset && { surveyPreset })), (supportDarkMode !== undefined && { supportDarkMode })), (demoMode !== undefined && { demoMode })), (branding && { branding })));
            return newState;
        }
        case 'SURVEY_INCREMENT_SEQ_NUM': {
            const newState = (0, cloneDeep_1.default)(state);
            const seqnum = newState._seqnum || 1;
            newState._seqnum = seqnum + 1;
            return newState;
        }
        case 'SURVEY_SET_FAILURE': {
            const data = action.data || {};
            const params = action.params || {};
            const metrika = data.params || [];
            const { reason, lang, supportDarkMode } = data;
            const { status } = action;
            const { slug } = params;
            return (0, cloneDeep_1.default)({ status, reason, slug, metrika, lang, inited: true, supportDarkMode });
        }
        case 'SURVEY_SCREENOUT_PENDING':
        case 'SURVEY_FINISH_PENDING': {
            return Object.assign(Object.assign({}, state), { status: 202 });
        }
        case 'SURVEY_SCREENOUT_SUCCESS': {
            const retpath = ((_a = action.data) === null || _a === void 0 ? void 0 : _a.redirect) || state.retpath;
            return Object.assign(Object.assign({}, state), { retpath, finish: true, status: 200 });
        }
        case 'QUOTAFULL': {
            const retpath = (_b = action.data) === null || _b === void 0 ? void 0 : _b.redirect;
            return Object.assign(Object.assign({}, state), { retpath, finish: true, status: 200 });
        }
        case 'SURVEY_FINISH_SUCCESS': {
            return Object.assign(Object.assign({}, state), { finish: true, status: 200 });
        }
        case 'LOGIC_PROCESS_START': {
            return Object.assign(Object.assign({}, state), { isLogicProcessing: true });
        }
        case 'LOGIC_PROCESS_END': {
            return Object.assign(Object.assign({}, state), { isLogicProcessing: false });
        }
        case 'NODE_VISIBILITY_CHANGED': {
            const newState = (0, cloneDeep_1.default)(state);
            action.nodes.forEach(node => {
                if (node.type === 'condition') {
                    (0, set_1.default)(newState, ['conditions', node.id], node.state);
                }
            });
            return newState;
        }
        case 'INTERVIEW_STARTED': {
            const { _ivid, _uid } = action.data;
            const newState = (0, cloneDeep_1.default)(state);
            return Object.assign(Object.assign(Object.assign({}, newState), { _uid: _uid || null }), (_ivid && { _ivid }));
        }
        case 'SET_HIDDEN_QUESTIONS_DISPLAY': {
            const { value } = action;
            const newState = (0, cloneDeep_1.default)(state);
            return Object.assign(Object.assign({}, newState), { displayHiddenQuestions: value });
        }
        default: {
            return state;
        }
    }
};
